import PropTypes, { any } from 'prop-types'
import { Link } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { actions } from 'modules/home/HomeReducer'
import { iconLogo } from 'components/Icons'

function HeaderLink({ styles, logo, alt, tagline }) {
  const dispatch = useDispatch()

  return (
    <Link
      to="/"
      className={styles?.a}
      onClick={() => dispatch(actions.setSearchTerm(''))}
      onKeyDown={e => {
        if (e.key === 'Enter' || e.key === ' ')
          dispatch(actions.setSearchTerm(''))
      }}
    >
      {iconLogo({ className: styles?.img })}
      <p style={{ textAlign: 'center' }}>{tagline}</p>
    </Link>
  )
}

HeaderLink.propTypes = {
  styles: any,
  logo: any,
  alt: PropTypes.string,
  tagline: PropTypes.string
}

export default HeaderLink
